import React from "react";
import { AVATAR_HERO, CONTEXT_SCENE, PERSONA_NAME } from "../lib/constants";
import { Feather, HeartHandshake, Laugh } from "lucide-react";

const traits = [
  {
    icon: Laugh,
    title: "Witty & Street-Smart",
    desc: "Speaks your language with the warmth and humour of the Naija street.",
  },
  {
    icon: Feather,
    title: "Wise Elder",
    desc: "Carries proverbs and grounded truths that make you nod and feel seen.",
  },
  {
    icon: HeartHandshake,
    title: "Calm Therapist",
    desc: "Validates your feelings and hands you practical steps to act on today.",
  },
];

export const About = () => {
  return (
    <section id="about" className="relative scroll-mt-20 bg-ink text-sand-light">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16 lg:py-24">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <span className="text-sm uppercase tracking-[0.2em] font-bold text-ochre">
              The Character
            </span>
            <h2 className="font-display font-black text-3xl sm:text-4xl lg:text-5xl mt-3 leading-tight">
              Who is {PERSONA_NAME}?
            </h2>
            <p className="text-sand-light/70 mt-5 leading-relaxed">
              A faceless, nameless wise friend built to serve one purpose — to support you through
              life's personal moments and help you work well with others. Feelings, confidence,
              relationships, family and teamwork. No real face. No real name. Just warm, useful
              support with a Naija soul.
            </p>

            <div className="grid sm:grid-cols-3 gap-4 mt-8">
              {traits.map((t) => (
                <div
                  key={t.title}
                  className="rounded-2xl bg-white/5 border border-white/10 p-5"
                  data-testid={`about-trait-${t.title.split(" ")[0].toLowerCase()}`}
                >
                  <t.icon size={22} className="text-clay" />
                  <p className="font-display font-bold text-lg mt-3">{t.title}</p>
                  <p className="text-sm text-sand-light/60 mt-1 leading-relaxed">{t.desc}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="relative">
            <img
              src={CONTEXT_SCENE}
              alt="Bustling street life in Lagos, Nigeria"
              className="rounded-3xl w-full h-[380px] object-cover"
            />
            <div className="absolute -bottom-6 -left-2 sm:left-6 flex items-center gap-3 bg-sand-light text-ink rounded-2xl p-3 pr-5 shadow-xl">
              <img
                src={AVATAR_HERO}
                alt=""
                className="w-12 h-12 rounded-full object-cover ring-2 ring-clay/40"
              />
              <div>
                <p className="font-display font-bold leading-tight">Grounded in the streets</p>
                <p className="text-xs text-ink/60">of Naija & all Africa</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export const Footer = () => (
  <footer className="bg-ink text-sand-light/50 border-t border-white/10">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 py-8 flex flex-col gap-3 text-sm">
      <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
        <p className="font-display text-ochre">Shabba Robo</p>
        <p>Wisdom, wit &amp; workable answers · Built for Africa</p>
      </div>
      <p className="text-xs text-sand-light/40 text-center sm:text-left" data-testid="legal-disclaimer">
        Shabba Robo is a personal support and teamwork friend offering emotional support and
        everyday guidance only — not legal, medical, or financial advice. For those matters,
        please consult a qualified professional.
      </p>
    </div>
  </footer>
);
